export function cleanEntity(constEntity) {
  let entity = { ...constEntity }
  for (let key in entity) {
    // console.log("cleanEntity", key)

    let value = entity[key]

    if (Array.isArray(value)) {
      let arrayValues = []

      for (let key2 in value) {
        let arrayValue = value[key2]
        if (arrayValue["@id"] !== undefined) {
          arrayValues.push(arrayValue["@id"])
        } else {
          arrayValues.push(arrayValue)
        }
      }
      entity[key] = arrayValues
    } else if (value["@id"] !== undefined) {
      entity[key] = value["@id"]
    }

    // console.log("cleanEntity", key, value, "=>", entity[key])
  }

  // console.log("cleanEntity done", entity)

  return entity
}
